const Support = () => {
  return (
    <div className="support">
      <img src="/public/assets/support.svg" />
      <div>
        <span className="supportTitle">پشتیبانی کاچار</span>
        <span>متخصصان ما در کاچار آماده خدمت</span>
        <span>رسانی به شما و ایجاد تجربه ی خریدی بهتر برای شما هستند</span>
      </div>
    </div>
  );
};

export default Support;
